import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import { Immutable } from 'nuclear-js';

export default CreateReactClass({
    displayName: 'batch-print-data',

    PropTypes: {
        batchOptionState: PropTypes.bool.isRequired,
        selectData: PropTypes.func.isRequired,
        nextButtonAction: PropTypes.func.isRequired,
        linkingStudies: PropTypes.instanceOf(Immutable.List).isRequired,
    },

    getDefaultProps() {
        return {
            linkingStudies: Immutable.List(),
        };
    },

    getInitialState() {
        return {
            selectedDataForPrinting: this.props.linkingStudies.toArray().map((ls) => ls.get('study')),
        };
    },

    componentDidUpdate(prevProps, prevState) {
        // During Family Report selection screen loading, the linking study data isn't initially known
        //     (data hasn't been received, yet). Therefore, the list of pre-selected items needs to be refreshed
        //     once the data is received.
        if (prevProps.linkingStudies.size != this.props.linkingStudies.size) {
            this.setState({
                selectedDataForPrinting: this.props.linkingStudies.toArray().map((ls) => ls.get('study')),
            });
            this.props.selectData(this.props.linkingStudies);
        }
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.batchOptionState) {
            this.reset();
        }
    },

    reset() {
        this.setState(this.getInitialState());
    },

    checkIndeterminateState() {
        return (
            this.state.selectedDataForPrinting.length > 0 &&
            this.state.selectedDataForPrinting.length < this.props.linkingStudies.size
        );
    },

    nextItem(event) {
        const selectedData = this.props.linkingStudies.filter((ls) =>
            this.state.selectedDataForPrinting.includes(ls.get('study'))
        );
        this.props.selectData(selectedData);
        this.props.nextButtonAction(event, 'pages');
    },

    toggleDataChange(study) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'select-data', study);

        let selectedStudies = this.state.selectedDataForPrinting;
        if (study == 'all') {
            selectedStudies =
                this.state.selectedDataForPrinting.length > 0 ? [] : this.getInitialState().selectedDataForPrinting;
        } else if (selectedStudies.includes(study)) {
            selectedStudies.splice(selectedStudies.indexOf(study), 1);
        } else {
            selectedStudies.push(study);
        }
        this.setState({
            selectedDataForPrinting: selectedStudies,
        });
        const selectedData = this.props.linkingStudies.filter((ls) => selectedStudies.includes(ls.get('study')));
        this.props.selectData(selectedData);
    },

    renderOption(study, title, seasonNumber) {
        const studyId = study.replace(/\s+/g, '-').toLowerCase();
        return (
            <div className="data-options batch-option" key={`data-${studyId}-${seasonNumber}`}>
                <input
                    type="checkbox"
                    id={`batch-print-${studyId}-data`}
                    checked={this.state.selectedDataForPrinting.includes(study)}
                    onChange={(event) => this.toggleDataChange(study)}
                />
                <label htmlFor={`batch-print-${studyId}-data`}>{title}</label>
            </div>
        );
    },

    render() {
        const dataOptions = this.props.linkingStudies.toArray().map((linkingStudy) => {
            return this.renderOption(
                linkingStudy.get('study'),
                linkingStudy.get('studyDisplayName'),
                linkingStudy.get('seasonNumber')
            );
        });
        const isChecked = this.state.selectedDataForPrinting.length == this.props.linkingStudies.size;

        return (
            <div className="data options-container">
                <div>
                    <h4>RECOMMENDED COMPARISONS DATA TO INCLUDE</h4>
                    <div className="batch-option" key="data-all">
                        <input
                            type="checkbox"
                            id={`batch-print-all-data`}
                            checked={isChecked}
                            ref={(input) => {
                                if (input) {
                                    input.indeterminate = this.checkIndeterminateState();
                                }
                            }}
                            onChange={(event) => this.toggleDataChange('all')}
                        />
                        <label htmlFor={`batch-print-all-data`}>Projected Proficiencies (recommended)</label>
                    </div>
                    {dataOptions}
                </div>
                <div className="button-container">
                    <button className="button-next" onClick={(event) => this.nextItem(event, 'pages')}>
                        NEXT
                    </button>
                </div>
            </div>
        );
    },
});
